export default "__VITE_ASSET__Dy3Cg8DA__"